// src/components/experts/ExpertCard.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import '../../styles/global.css'; // Ensure global styles are imported

const ExpertCard = ({ expert }) => {
  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
    hover: { scale: 1.05 },
  };

  return (
    <motion.div
      className="relative rounded-lg shadow-md overflow-hidden"
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      transition={{ duration: 0.3 }}
    >
      {/* Animated Gradient Border */}
      <div
        className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-purple-500 to-blue-500 rounded-lg z-[-1] animate-gradient-border"
        style={{
          padding: '2px', // Adjust for border thickness
          mask: 'linear-gradient(#fff 0%, #fff 100%)',
          maskComposite: 'destination-out',
          WebkitMask: 'linear-gradient(#fff 0%, #fff 100%)',
          WebkitMaskComposite: 'destination-out',
        }}
      />
      <div
        className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-pink-500 to-yellow-500 rounded-lg z-[-2] animate-gradient-border"
        style={{
          padding: '2px', // Adjust for border thickness
          mask: 'linear-gradient(#fff 0%, #fff 100%)',
          maskComposite: 'destination-out',
          WebkitMask: 'linear-gradient(#fff 0%, #fff 100%)',
          WebkitMaskComposite: 'destination-out',
          animationDirection: 'reverse',
          animationDuration: '3s',
        }}
      />

      {/* Card Content with Background Color */}
      <div className="bg-gray-50 p-6 flex flex-col items-center text-center">
        <div className="relative w-32 h-32 rounded-full overflow-hidden mb-4">
          <img
            src={expert.image}
            alt={expert.name}
            className="object-cover w-full h-full"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/assets/images/placeholder-expert.png';
            }}
          />
        </div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">{expert.name}</h3>
        <p className="text-gray-600 text-sm mb-1">{expert.title}</p>
        {expert.specialization && (
          <p className="text-gray-600 text-xs italic mb-3">{expert.specialization}</p>
        )}
        {expert.year && (
          <p className="text-gray-500 text-xs mb-2">({expert.year})</p>
        )}
        {expert.bio && (
          <p className="text-gray-700 text-sm mb-4">{expert.bio.substring(0, 100)}...</p>
        )}
        {/* You can add a "Read More" button or other details here */}
      </div>
    </motion.div>
  );
};

ExpertCard.propTypes = {
  expert: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    specialization: PropTypes.string,
    year: PropTypes.string,
    bio: PropTypes.string,
  }).isRequired,
};

export default ExpertCard;